import { Flex, Text } from "@chakra-ui/react";
import { FieldProps } from "@rjsf/utils";
import { FormattedMessage } from "react-intl";

import { RanaLoading } from "@nens/ranalib";
import { DISABLED_OPACITY } from "@nens/ranalib";
import { displayBytes } from "@nens/shared-utils";

import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";

import { useAreaSize } from "../hooks/use-area-size";

export const FileSize = (props: FieldProps) => {
  const { schema, registry } = props;

  const { isLoading, knowsAreaSize, currentBytes } = useAreaSize(props);

  const ranaWidget = getRanaWidgetFromProperty(schema, "cell_size");
  const extentSource = ranaWidget?.extent_source;

  const extentSchema =
    registry.rootSchema.properties && registry.rootSchema.properties[extentSource + ""];
  const extentSourceTitle =
    (typeof extentSchema !== "boolean" && extentSchema?.title) || extentSource?.replace(/_/g, " ");

  if (isLoading)
    return (
      // &nbsp; is to make sure the height stays the same
      <Flex>
        &nbsp;
        <RanaLoading boxSize={4} />
        &nbsp;
      </Flex>
    );

  if (knowsAreaSize) return displayBytes(currentBytes) ?? "-";

  return (
    <Text opacity={DISABLED_OPACITY}>
      <FormattedMessage
        id="process.need_extent_file"
        defaultMessage="A {fileName} file is required to calculate file size"
        values={{ fileName: extentSourceTitle }}
      />
    </Text>
  );
};
